import { $l } from '../locales';
import { routes } from '../routing';

export const MIN_SEARCH_STRING_LENGTH = 3;

export const COMMUNITY_FORUM_QUESTION_TYPE = 'community_forum_question';
export const TICKET_TYPE = 'ticket';
export const TOPIC_TYPE = 'topic';

export const types = [
  {
    slug: TOPIC_TYPE,
    title: $l('SEARCH.KNOWLEDGE_BASE'),
    link: routes.knowledgeBaseTopic,
  },
  {
    slug: TICKET_TYPE,
    title: $l('SEARCH.TICKETS'),
    link: routes.ticket,
  },
  {
    slug: COMMUNITY_FORUM_QUESTION_TYPE,
    title: $l('SEARCH.COMMUNITY'),
    link: routes.communityQuestion,
  },
];
